<template>
    <div class="p-16 bg-white rounded shadow">
        <tabs :active-key="activeItem"
              :items="tabs"
              size="lg"
              @set-active="dashboardStore.activityItem($event)"
        >
            <template v-show="tabs[activeItem].settings"
                      #settings
            >
                <checkbox v-model="showOnlyMyTasks"
                          class="mr-8 whitespace-nowrap"
                          @change="changeOnlyMyTasks"
                >
                    <span class="font-normal">{{ $t('tasks.my_tasks_only') }}</span>
                </checkbox>
                <checkbox
                    v-model="showFinishedTasks"
                    class="mr-8"
                    @change="setShowFinishedTasks"
                >
                    <span class="font-normal">{{ $t('tasks.tasks_done') }}</span>
                </checkbox>
            </template>
        </tabs>

        <tasks-detail
            v-show="activeItem === 'tasks'"
            :key="'tasks_' + _uid"
            ref="taskdetail"
            :use-title="false"
            filterable
            max-height="max-h-564 min-h-480 overflow-y-auto"
        />

        <alerts
            v-show="activeItem === 'activity'"
            :use-dropdown="false"
        />
    </div>
</template>

<script>
import TasksDetail from '../../components/ui/TasksDetail.vue';
import Tabs from '../../components/navigation/Tabs.vue';
import Alerts from '../../components/ui/Alerts.vue';
import Checkbox from '../../components/forms/Checkbox';
import {mapStores} from "pinia";
import {useMainStore} from "../../state/store";
import {useDashboardStore} from "../../state/modules/dashboard";

export default {
    components: {Checkbox, Alerts, Tabs, TasksDetail},
    data: function () {
        return {
            showOnlyMyTasks: true,
            showFinishedTasks: false,
        };
    },
    computed: {
        ...mapStores(useMainStore, useDashboardStore),
        unreadNotificationCount(){
           return this.mainStore.unreadNotificationCount;
        },
        activeItem(){
            return this.dashboardStore.activity;
        },
        tabs() {
            return {
                'tasks': {
                    'title': this.$t('tasks.tasks'),
                    'icon': 'task-alt',
                    'settings': true,
                },
                'activity': {
                    'title': this.$t('notifications.title'),
                    'icon': 'notifications',
                    'badge': 'info',
                    'count': this.unreadNotificationCount,
                },
            };
        },
    },
    methods: {
        changeOnlyMyTasks() {
            this.$refs.taskdetail.setOnlyMyTasks();
        },
        setShowFinishedTasks() {
            this.$refs.taskdetail.setShowFinishedTasks();
        },
    },
};
</script>